import { useContext } from 'react';

import {
  Container,
  Title,
  ButtonContainer,
  Button,
  Row,
} from './AffectedItems.styles';
import { CreateUpdateContext } from '../../CreateUpdatesDialog.query';
import { Menu } from './components/ManufacturersList/Menu';
import { ProductList } from './components/ProductsList/ProductList';

const AffectedItems = () => {
  const { relatesTo } = useContext(CreateUpdateContext);

  return (
    <Container>
      <Row>
        <ButtonContainer>
          {relatesTo.get() === 'manufacturers' && (
            <Row>
              <Title>This update will be added to:</Title>
              <Button type="button">
                <Menu />
              </Button>
            </Row>
          )}

          {relatesTo.get() === 'products' && <ProductList />}
        </ButtonContainer>
      </Row>
    </Container>
  );
};

export { AffectedItems };
